import { styled } from '@pata-app/themes';

export const FeatureSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 70px;

  max-width: 1200px;
  margin: auto;

  padding: ${({ $rightAligned }) => ($rightAligned ? '70px 0' : '0')};

  img {
    width: 100%;

    object-fit: cover;

    border-radius: ${({ theme }) => theme.core.border.element.radius}px;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    flex-direction: ${({ $rightAligned }) => ($rightAligned ? 'row' : 'row-reverse')};

    img {
      width: 400px;
      min-width: 400px;
    }
  }
`;

export const SectionTitle = styled.h3`
  font-size: ${({ theme }) => theme.core.fontSizes.xxl}px;

  margin-top: 0;

  color: ${({ theme }) => theme.core.colors.primary.green.medium};
`;

export const FeaturesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${({ theme }) => theme.core.sizing[3]}px;

  @media ${({ theme }) => `${theme.core.breakpoints.s}`} {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  }
`;

export const FeatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.core.sizing[2]}px;

  p {
    margin: 0;
  }

  button {
    max-width: 150px;
  }
`;
